import { SeoViewModel } from "../core/seo";
export class News {
    Id: number;
    Title: string;
    Text: string;
    TemplateUrl: string;
    Description: string;
    ImageUrl: string;
    Date: Date;
    FormattedDate: string;
    SeoUrl: string;
    RouterLink: any[];
    Lang: string;
    IdRow: number;
    IdCategory: number;
    Name_Category: string;
    CategoryRouterLink: string;
    ImageHeader: string;
}

export class NewsDetails {
    Id: number;
    Title: string;
    LongDescription: string;
    HeaderImage: string;
    Date: Date;
    FormattedDate: string;
    TemplateUrl: string;
    TemplateHtml: string;
    Author: string;
    SliderImages: SliderViewModel[];
    SeoInformation: SeoViewModel;
    Lang: string;
    SeoUrl: string;
    RouterLink: any[];
    ArticleCategories: Array<ArticleCategory>;
    BreadcrumbsInfo:any;
    UrlRedirect: string="";
    FooterData: any;
    HeaderData: any;
}

export class SliderViewModel {
    SliderUrl: string;
}
export class ArticleCategory {
    Name: string;
    Id: number;
    DefaultValue: number;
    Code_Category: string;
    CategorySystem: boolean;
    ShowCategory: boolean;
    SeoUrl: string;
    HeaderImage: string;
    ShortDescription: string;
    LongDescription: string;
    RouterLink: any[];
    TemplateUrl: string;
    TemplateHtml: string;
    Lang: string;
    Image: string;

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/cms/news-list.ts